import { PageRequest } from '@/core/request/PageRequest';

export interface KitsQueryFilters extends PageRequest {
  description?: string;
}

export interface Kit {
  description: string;
  id: number;
  increaseDecrease: number;
  items: [
    {
      id: number;
      itemId: number;
      itemType: KitItemType;
      kitDiscount: [
        {
          companyId: number;
          id: number;
          increaseDecrease: number;
        },
      ];
      quantity: number;
    },
  ];
  matrixId: number;
}

export interface KitReduced {
  description: string;
  id: number;
}

export enum KitItemType {
  part = 'PART',
  task = 'TASK',
}

export const kitTypeColor = {
  [KitItemType.part]: 'blue',
  [KitItemType.task]: 'yellow',
};

export const kitTypeItem = {
  [KitItemType.part]: 'Peça',
  [KitItemType.task]: 'Serviço',
};

export interface KitCreateFormValues {
  description: string;
  increaseDecrease: number;
}

export interface KitItemCreate {
  itemId: number;
  itemType: KitItemType;
  description: string;
  barcode?: string;
  originalCode?: string;
  sku?: string;
  manufacturingCode?: string;
  companyCode?: number;
  temparioCode?: string;
  manufacturer?: {
    id: number;
    name: string;
  };
  quantity: number;
  increaseDecrease?: number;
  companies: KitCompany[];
}

export interface KitItemEdit extends KitItemCreate {
  id: number;
}

export interface KitCompany {
  id?: number;
  companyId: number;
  name: string;
  price: number;
  increaseDecrease?: number;
  unitPrice?: number;
}

export interface CreateKitRequest {
  description: string;
  increaseDecrease?: number;
  items: CreateKitItem[];
}

export interface CreateKitResponse extends CreateKitItem {
  id: number;
}

export interface EditKitRequest extends CreateKitRequest {
  id: number;
}

export interface CreateKitItem {
  itemId: number;
  itemType: KitItemType;
  kitDiscount: CreateKitDiscount[];
  quantity: number;
}

export interface CreateKitDiscount {
  companyId: number;
  increaseDecrease?: number;
}

export interface CountKit {
  totalQuantity: number;
}
